import React, { useEffect, useState } from 'react';
import { Checkbox } from 'Views/Components/Checkbox/Checkbox';
import Popover from 'Views/Components/_HumanWritten/Popover';
import { useStaffTransactionsStore, ColumnConfig } from './StaffTransactionsFilterStore';

export const StaffTransactionsColumnSelector = () => {
	const { visibleColumns, setVisibleColumns } = useStaffTransactionsStore();

	const [tempColumns, setTempColumns] = useState<ColumnConfig[]>(visibleColumns);

	// Sync temp columns when visibleColumns changes
	useEffect(() => {
		setTempColumns(visibleColumns);
	}, [visibleColumns]);

	const visibleCount = tempColumns.filter(col => col.visible && !col.locked).length;
	const totalCount = tempColumns.filter(col => !col.locked).length;

	const onAfterClose = () => {
		const hasChanges = tempColumns.some((col, idx) => col.visible !== visibleColumns[idx].visible);

		if (hasChanges) {
			setVisibleColumns(tempColumns);
		}
	};

	const handleToggle = (key: string) => {
		setTempColumns(prev =>
			prev.map(col => (col.key === key && !col.locked ? { ...col, visible: !col.visible } : col)),
		);
	};

	const handleSelectAll = () => {
		setTempColumns(prev => prev.map(col => ({ ...col, visible: true })));
	};

	const isAllColumnsSelected = visibleCount === totalCount;

	const handleDeselectAll = () => {
		setTempColumns(prev => prev.map(col => (col.locked ? col : { ...col, visible: false })));
	};

	return (
		<Popover
			popoverClassName="fh-popover column-selector-popover"
			onAfterClose={onAfterClose}
			buttonTestId="transactions-columns-button"
			buttonContent={(() => {
				return (
					<>
						<p className="grey">Columns</p>
						<span>
							{visibleCount}/{totalCount}
						</span>
					</>
				);
			})()}
			popoverContent={() => (
				<>
					<Checkbox
						className="fh-popover__checkbox fh-popover__list-item"
						model={{
							value: isAllColumnsSelected,
						}}
						modelProperty="value"
						label="All"
						onChecked={(_, value) => {
							if (!value) {
								handleDeselectAll();
							} else {
								handleSelectAll();
							}
						}}
					/>
					<div className="column-selector__list">
						{tempColumns.map(column => (
							<Checkbox
								key={column.key}
								className="fh-popover__checkbox fh-popover__list-item"
								model={{ value: column.visible }}
								modelProperty="value"
								label={column.label}
								isReadOnly={column.locked}
								onChecked={(_, value) => handleToggle(column.key)}
							/>
						))}
					</div>
				</>
			)}
		/>
	);
};
